import { render, staticRenderFns } from "./CotizadorMovil.vue?vue&type=template&id=6ae53023&"
import script from "./CotizadorMovil.vue?vue&type=script&lang=ts&"
export * from "./CotizadorMovil.vue?vue&type=script&lang=ts&"
import style0 from "./CotizadorMovil.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports